import { render, staticRenderFns } from "./ArticleAccount.vue?vue&type=template&id=0f07e244&scoped=true"
import script from "./ArticleAccount.vue?vue&type=script&lang=js"
export * from "./ArticleAccount.vue?vue&type=script&lang=js"
import style0 from "./ArticleAccount.vue?vue&type=style&index=0&id=0f07e244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07e244",
  null
  
)

export default component.exports